var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 28,
    viewBox: "0 0 45 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5 24.3139C20.1169 26.3704 17.0255 27.6119 13.6475 27.6119C6.11021 27.6119 0 21.4308 0 13.806C0 6.18114 6.11021 0 13.6475 0C17.0255 0 20.1169 1.2415 22.5 3.29806C24.8831 1.2415 27.9745 0 31.3525 0C38.8898 0 45 6.18114 45 13.806C45 21.4308 38.8898 27.6119 31.3525 27.6119C27.9745 27.6119 24.8831 26.3704 22.5 24.3139Z",
    fill: "#ED0006"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5 24.3139C25.4344 21.7816 27.2951 18.0136 27.2951 13.806C27.2951 9.59833 25.4344 5.83033 22.5 3.29806C24.8831 1.2415 27.9745 0 31.3525 0C38.8898 0 45 6.18114 45 13.806C45 21.4308 38.8898 27.6119 31.3525 27.6119C27.9745 27.6119 24.8831 26.3704 22.5 24.3139Z",
    fill: "#F9A000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5 3.29813C25.4344 5.8304 27.2951 9.59838 27.2951 13.806C27.2951 18.0136 25.4344 21.7816 22.5 24.3138C19.5657 21.7816 17.705 18.0136 17.705 13.806C17.705 9.59838 19.5657 5.8304 22.5 3.29813Z",
    fill: "#FF5E00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.8b98d059dd3d23d876231f9f1667628a.svg";
export { ForwardRef as ReactComponent };